<template>
  <div class="voz-guideline-family-content" id="identidade-verbal-voz-proxima-e-familiar" data-search-anchor>
    <h1 class="voz-guideline-family-title">{{ vozGuidelineFamilyTitle }}</h1>
    <p class="voz-guideline-family-paragraph">{{ vozGuidelineFamilyParagraph }}</p>

    <div class="voz-guideline-family-wrapper">
      <div class="voz-guideline-family-card" :style="{ backgroundImage: `url(${vozGuidelineFamilyImageSrc})` }">
        <div class="voz-guideline-family-overlay">

          <h1 class="voz-guideline-family-number">1</h1>

          <div class="voz-guideline-family-content-text">
            <h3 class="voz-guideline-family-card-title">
              {{ vozGuidelineFamilyCardTitle }}
            </h3>

            <p class="voz-guideline-family-text">
              {{ vozGuidelineFamilyText }}
            </p>
          </div>

        </div>
      </div>

      <div class="voz-guideline-family-column">
        <div class="voz-family-icon-paragraph-title">
          <IconCheck />
          <h1 class="voz-guideline-family-prefer-paragraph-title">
            {{ vozGuidelineFamilyParagraphPref }}
          </h1>
        </div>

        <p class="voz-guideline-family-prefer-paragraph">{{ vozGuidelineFamilyParagraph1 }}</p>
        <p class="voz-guideline-family-prefer-paragraph-ex">{{ vozGuidelineFamilyParagraph2 }}</p>
        <p class="voz-guideline-family-prefer-paragraph">{{ vozGuidelineFamilyParagraph3 }}</p>
        <p class="voz-guideline-family-prefer-paragraph-ex">{{ vozGuidelineFamilyParagraph4 }}</p>
        <p class="voz-guideline-family-prefer-paragraph">{{ vozGuidelineFamilyParagraph5 }}</p>
        <p class="voz-guideline-family-prefer-paragraph-ex">{{ vozGuidelineFamilyParagraph6 }}</p>
      </div>
      <div class="gap-col"></div>
      <div class="voz-guideline-family-column">
        <div class="voz-family-icon-paragraph-title">
          <IconCancel />
          <h1 class="voz-guideline-family-prefer-paragraph-title">
            {{ vozGuidelineFamilyParagraphEvit }}
          </h1>
        </div>
        <p class="voz-guideline-family-evit-paragraph">{{ vozGuidelineFamilyParagraphEvit1 }}</p>
        <p class="voz-guideline-family-evit-paragraph-ex">{{ vozGuidelineFamilyParagraphEvit2 }}</p>
        <p class="voz-guideline-family-evit-paragraph">{{ vozGuidelineFamilyParagraphEvit3 }}</p>
        <p class="voz-guideline-family-evit-paragraph-ex">{{ vozGuidelineFamilyParagraphEvit4 }}</p>
        <p class="voz-guideline-family-evit-paragraph">{{ vozGuidelineFamilyParagraphEvit5 }}</p>
        <p class="voz-guideline-family-evit-paragraph-ex">{{ vozGuidelineFamilyParagraphEvit6 }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import IconCancel from '@/assets/icons/IconCancel.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import VozPageMixin from '@/mixins/voz-page-mixin'
import { VozPageStore } from '@/store/verbal-identity-page/voz-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck, IconCancel } })
export default class VozGuidelineFamilySection extends Mixins(VozPageMixin) {
  vozPageStore: PageStoreContract = getModule(VozPageStore, this.$store)

  get vozGuidelineFamilyTitle(): string {
    return this.getElementTitle(4, 0)
  }

  get vozGuidelineFamilyParagraph(): string {
    return this.getElementText(4, 1)
  }

  get vozGuidelineFamilyImageSrc(): string {
    return this.getElementMedia(4, 2)
  }

  get vozGuidelineFamilyCardTitle(): string {
    return this.getElementTitle(4, 2)
  }

  get vozGuidelineFamilyText(): string {
    return this.getElementText(4, 2)
  }

  //colum
  get vozGuidelineFamilyParagraphPref(): string {
    return this.getElementTitle(4, 3)
  }

  get vozGuidelineFamilyParagraph1(): string {
    return this.getElementText(4, 3)
  }

  get vozGuidelineFamilyParagraph2(): string {
    return this.getElementText(4, 4)
  }

  get vozGuidelineFamilyParagraph3(): string {
    return this.getElementText(4, 5)
  }

  get vozGuidelineFamilyParagraph4(): string {
    return this.getElementText(4, 6)
  }

  get vozGuidelineFamilyParagraph5(): string {
    return this.getElementText(4, 7)
  }

  get vozGuidelineFamilyParagraph6(): string {
    return this.getElementText(4, 8)
  }

  //colum
  get vozGuidelineFamilyParagraphEvit(): string {
    return this.getElementTitle(4, 9)
  }

  get vozGuidelineFamilyParagraphEvit1(): string {
    return this.getElementText(4, 9)
  }

  get vozGuidelineFamilyParagraphEvit2(): string {
    return this.getElementText(4, 10)
  }

  get vozGuidelineFamilyParagraphEvit3(): string {
    return this.getElementText(4, 11)
  }

  get vozGuidelineFamilyParagraphEvit4(): string {
    return this.getElementText(4, 12)
  }

  get vozGuidelineFamilyParagraphEvit5(): string {
    return this.getElementText(4, 13)
  }

  get vozGuidelineFamilyParagraphEvit6(): string {
    return this.getElementText(4, 14)
  }

  async getVozPage(): Promise<void> {
    await this.vozPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.vozPageStore.isLoading) {
      await this.getVozPage()
    }
  }
}
</script>

<style lang="scss">
.voz-guideline-family-content {
  display: grid;
  justify-content: center;
  margin-top: 150px;
  max-width: 1032px;
}

.voz-guideline-family-title {
  font-size: 48px;
  font-weight: 400;
  line-height: 52px;
  letter-spacing: -0.01em;
  text-align: center;
  width: 790px;
  margin: 0 auto;
}

.voz-guideline-family-paragraph {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  width: 503px;
  margin: 0 auto;
  margin-top: 49px;
}

.voz-guideline-family-wrapper {
  display: grid;
  grid-template-columns: 369px 307px 50px 307px;
  width: 1032px;
  margin: 0 auto;
  margin-top: 148px;
}

.voz-guideline-family-card {
  width: 341px;
  height: 681px;
  border-radius: 16px;
  overflow: hidden;

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  position: relative;
}

.voz-guideline-family-overlay {
  position: absolute;
  inset: 0;

  padding: 24px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;  

  color: #fff;
}

.voz-guideline-family-number {
  font-size: 267px;
  font-weight: 600;
  margin: 0;
}

.voz-guideline-family-content-text {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.voz-guideline-family-card-title {
  font-family: GlobotipoCorporativaRegular;
  font-size: 28px;
  font-weight: 400;
  width: 140px;
  margin: 0;
}

.voz-guideline-family-text {
  font-family: GlobotipoCorporativaTextosRegular;
  font-size: 18px;
  width: 200px;
  margin: 0;
}

.voz-family-icon-paragraph-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.voz-guideline-family-column {
  display: flex;
  flex-direction: column;
}

.voz-guideline-family-prefer-paragraph-title {
  font-weight: 400;
  font-size: 32px;
  line-height: 36px;
}

.voz-guideline-family-prefer-paragraph-ex,
.voz-guideline-family-evit-paragraph-ex {
  margin-top: 0;
  margin-bottom: 32px;
}

.voz-guideline-family-prefer-paragraph,
.voz-guideline-family-evit-paragraph {
  margin-top: 0;
  margin-bottom: 0;
}

.voz-guideline-family-evit-paragraph:first-of-type {
  white-space: pre-wrap;
}

.voz-guideline-family-prefer-paragraph,
.voz-guideline-family-evit-paragraph,
.voz-guideline-family-prefer-paragraph-ex,
.voz-guideline-family-evit-paragraph-ex {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

.voz-guideline-family-prefer-container,
.voz-guideline-family-evit-container {
  border-radius: 16px;
  margin-top: 24px;
  margin-bottom: 50px;
}
</style>
